/**
* Allows options in the Rx form to be disabled via the user's swatch selections
* in product-customizer. Form options disabled in this way get:
*   - A [disabled] attribute
*   - A tooltip explaining the disabled state
*/
(function (window, document) {
  window.componentEvents.on('consumer-rx-form-instantiate', init);

  function init(form) {

    // Check each selected PDP swatch for a `data-custom-exclude-form-option`
    // attribute.
    const selectedSwatches = document.querySelectorAll('[data-custom-exclude-form-option][checked="true"]');
    selectedSwatches.forEach(swatch => {
      disableOptions(form, swatch);
    });

    // Update disabled form options when the user's swatch selection changes.
    componentEvents.on('product-options-updated', function () {
      const exclusionSwatches = document.querySelectorAll('[data-custom-exclude-form-option]');

      // If no swatches found with form option exclusions found, do nothing.
      if (!exclusionSwatches.length) return;

      // Update form exclusions based on new selections.
      exclusionSwatches.forEach(swatch => {
        disableOptions(form, swatch);
      });
    });
  }

  // Disables options in a Consumer Rx form, if options within that form match
  // those indicated to be excluded by a given swatch.
  function disableOptions(form, swatch) {
    const customExcludedOptionIds = (swatch.dataset.customExcludeFormOption || '').split(':');

    // Get an array of form inputs using the excluded option IDs,
    // filtering out any that are not found within this form.
    const formOptions = customExcludedOptionIds
      .map(id => form.querySelector(`#${id}`)).filter(el => !!el);

    formOptions.forEach((formOption) => {
      // Disable this option if it's ID is in the list of excluded items, then
      // add or remove its tooltip depending on whether it's disabled or not.
      formOption.disabled = swatch.checked;
      if (formOption.disabled) {
        const tooltipOptions = {
          tooltipParent: getTooltipParent(formOption),
          tooltipModifiers: ['tooltip--alternate'],
          tooltipIcon: true,
        };
        componentEvents.emitEvent('tooltip-build', [tooltipOptions]);
      } else {
        componentEvents.emitEvent('tooltip-destroy', [getTooltipParent(formOption)]);
      }
    });
  }

  // Get the parent item to append the tooltip to.
  function getTooltipParent(formOption) {
    return document.querySelector(`label[for="${formOption.id}"]`);
  }

})(window, document);
